import UI from "/javascripts/utils/UI";
import bus from "/javascripts/bus";
import scrollY from "/javascripts/utils/scrollY";

UI(
  {
    component: ".js-siteHeader",
    toggleMenu: ".js-siteHeader-toggleMenu",
    contactCta: ".js-siteHeader-contactCta",
    contactReskin: ".js-siteHeader-contact",
    logoText: ".js-siteHeader-logoText",
    menuToggleText: ".js-siteHeader-menuToggleText",
    bars: [".js-siteHeader-toggleMenuBar"],
  },
  async ({
    component,
    toggleMenu,
    contactCta,
    contactReskin,
    logoText,
    bars,
  }) => {
    await import("gsap/CSSPlugin");
    const TimelineLite = await import("gsap/TimelineLite").then(
      (gsap) => gsap.TimelineLite,
    );
    const state = {
      isMenuOpen: false,
      timeline: createTimeLine(),
      previousIsLightState: null,
      hash: null,
    };

    if (component.classList.contains("is-light")) {
      bus.on("onUpdateScrollFromTop", onUpdateScrollFromTop);
    }

    bus.on("updateSiteHeader", onUpdateSiteHeader);
    bus.on("onToggleHeader", onToggleHeader);
    bus.on("closeMenu", doCloseMenu);
    bus.on("menuAfterClose", doMenuAfterClose);
    bus.on("windowScroll", onWindowScroll);

    if (document.readyState !== "complete") {
      document.addEventListener(
        "readystatechange",
        ({ target: { readyState } }) => {
          if (readyState === "complete") onWindowScroll();
        },
      );
    }

    toggleMenu.addEventListener("click", doToggleMenu);

    function doCloseMenu(hash) {
      doToggleMenu(false);
      state.hash = hash;
    }

    function doMenuAfterClose() {
      window.location.hash = state.hash;
    }

    function doToggleMenu(evt, callback) {
      if (evt) evt.preventDefault();
      toggleMenu.blur();
      state.isMenuOpen = !state.isMenuOpen;
      bus.emit("toggleMenu", state.isMenuOpen);
      component.classList.toggle("is-open", state.isMenuOpen);
      if (state.isMenuOpen) {
        state.timeline.play();
        state.isLightDesired = component.classList.contains("is-light");
        if (contactCta) {
          state.isContactCtaDesired =
            !contactCta.classList.contains("is-hidden");
          contactCta.classList.add("is-hidden");
        }
        component.classList.remove("is-light");
      } else {
        state.timeline.reverse();
        component.classList.toggle("is-light", state.isLightDesired);
        if (contactCta)
          contactCta.classList.toggle("is-hidden", !state.isContactCtaDesired);
      }
      if (typeof callback === "function") callback();
    }

    function createTimeLine() {
      const tl = new TimelineLite({ paused: true });
      tl.to(
        bars[0],
        0.225,
        { transformOrigin: "right center", rotation: "-45deg", scaleX: 1.1 },
        "0",
      );
      tl.to(
        bars[1],
        0.225,
        { transformOrigin: "right center", rotation: "45deg", scaleX: 1.1 },
        "0",
      );
      tl.to(bars[2], 0.225, { opacity: 0 }, "0");
      return tl;
    }

    function onUpdateScrollFromTop({ boundingClientRect }) {
      const { y: currentPosition } = boundingClientRect;
      const minTriggerPosition = component.clientHeight / 2;
      toggleIsLightSiteHeader(currentPosition > minTriggerPosition);
    }

    function onUpdateSiteHeader({
      isLight,
      showContactCta,
      showcontactReskin,
    }) {
      toggleIsLightSiteHeader(isLight);
      if (contactCta) contactCta.classList.toggle("is-hidden", !showContactCta);
      contactReskin.classList.toggle("is-hidden", !showcontactReskin);
    }

    function toggleIsLightSiteHeader(isLight) {
      if (state.previousIsLightState === isLight) {
        return;
      }

      state.previousIsLightState = isLight;
      component.classList.toggle("is-light", isLight);
    }

    function onToggleHeader(isOpen) {
      component.classList.toggle("is-hiding", isOpen);
    }

    function onWindowScroll() {
      checkForOnTopOfPage();
      maybeAnimateLogoText();
    }

    function checkForOnTopOfPage() {
      component.classList.toggle("has-reachedTop", scrollY() < 100);
    }

    function maybeAnimateLogoText() {
      if (!logoText || state.isMenuOpen) {
        return;
      }

      const logoTextShouldBeVisible = scrollY() >= 50;
      logoText.classList.toggle("is-hidden", logoTextShouldBeVisible);
      // menuToggleText.classList.toggle('is-hidden', logoTextShouldBeVisible)
    }
  },
);
